export default function getInitState() {
    return {
        dataTableOptions: {
            initOnRender: false
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Keresés',
                event_name: "customClick",
                class: "btn btn btn-danger my-custom-class",
                event_payload: 'search'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Exportálás',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'export'
            },
        ],
        headerFields: [
            {
                name: "id",
                label: "id",
                visibility: false
            },
            {
                name: "resultMonth",
                label: "Hónap",
                visibility: true,
                slot_name: 'date_month_format'
            },
            {
                name: "treatmentType",
                label: "Kezelés",
                visibility: true
            },
            {
                name: "treatmentStatus",
                label: "Kezelés státusza",
                visibility: true
            },
            {
                name: "attendanceStatus",
                label: "Ellátás státusza",
                visibility: true
            },
            {
                name: "darab",
                label: "Darab",
                visibility: true,
            }
        ]
    }
}
